import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { Polygon } from '@vectronic/base-map';

@Component({
  selector: 'sm-delete-dialog',
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './delete-dialog.component.html',
  styleUrl: './delete-dialog.component.scss',
})
export class DeleteDialogComponent {
  data: { selectedFence: Polygon } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DeleteDialogComponent>);
  result: Polygon['insidePoint'];

  deleteFence(fence: Polygon) {
    this.dialogRef.close(fence.insidePoint);
  }
}
